require('./overrides.scss')

export default {
  theme: {
    themes: {
      dark: {
        primary: '#56CA00',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#F60',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
      light: {
        primary: '#56CA00',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#F60',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },

    },
  },
}
